module.exports = __webpack_public_path__ + "media/images/story/typo/declarationNormal-62c7f3c90ad0e799189cf11834871d48.svg";